import { Avatar, Drawer } from 'antd'
import React, { useState } from 'react'
import { ContainerGaveta } from './styled'
import ButtonCustom from '../../../ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faHandshake, faUser, faXmark } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'
import AvatarImg from '../lista_aniversariantes/meta'
import { NavegacaoDrawer } from '../../../../Views/app/recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'

interface PropsGaveta {
  cod?: number
  dados?: any[]
  open?: boolean
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

const GavetaAniversariante: React.FC<PropsGaveta> = ({ cod, dados, open, setOpen }) => {
  const tirarCodDuplicado = (arr, cod) => {
    const filtered = arr.filter((item) => item.cod === cod)
    return filtered.length > 0 ? [filtered[0]] : []
  }

  const dadosFilter = tirarCodDuplicado(dados, cod)

  function calcularTempoEmpresa(dataAdmissao) {
    const hoje = dayjs()
    const admissao = dayjs(dataAdmissao)

    const anos = hoje.diff(admissao, 'year')
    const meses = hoje.diff(admissao.add(anos, 'year'), 'month')

    const anoTexto = anos === 1 ? 'ano' : 'anos'
    const mesTexto = meses === 1 ? 'mês' : 'meses'

    if (anos > 0 && meses > 0) {
      return `${anos} ${anoTexto} e ${meses} ${mesTexto}`
    } else if (anos > 0) {
      return `${anos} ${anoTexto}`
    } else {
      return `${meses} ${mesTexto}`
    }
  }

  const getInitials = (name) => {
    if (!name) return ''
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase()
  }

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      closeIcon={false}
      placement='right'
      width={'30%'}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ padding: '10px 10px' }}
      title={
        <NavegacaoDrawer>
          <ButtonCustom
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
            type='tertiary'
            onClick={() => setOpen(false)}
            style={{ marginLeft: -10 }}
          >
            Fechar
          </ButtonCustom>
        </NavegacaoDrawer>
      }
    >
      <ContainerGaveta>
        <h2>Perfil do aniversariante</h2>
        {dadosFilter?.map((item) => {
          const tempoEmpresa = calcularTempoEmpresa(item?.tempo_empresa)
          return (
            <div key={item?.cod} className='informacoes__perfil'>
              <div className='img__perfil'>
                <AvatarImg
                  src={item?.doc_foto_url ?? item?.doc_foto_perfil_url}
                  nome={item?.nome}
                  size={170}
                />
              </div>
              <h3 className='nome'>{`${item?.nome} ${item?.sobrenome}`.toLocaleLowerCase()}</h3>
              <div className='dados__aniversariantes'>
                <div className='idade__empresa'>
                  <p>
                    <FontAwesomeIcon icon={faBriefcase} />
                    <strong>Tempo na empresa:</strong>
                  </p>
                  {tempoEmpresa}
                </div>
                <div className='idade__empresa'>
                  <p>
                    <FontAwesomeIcon icon={faUser} />
                    <strong>Idade:</strong>
                  </p>
                  {item?.idade === null ? '' : `${item.idade} anos`}
                </div>
              </div>
            </div>
          )
        })}
      </ContainerGaveta>
    </Drawer>
  )
}

export default GavetaAniversariante
